import { dispatchCustomEvent } from '../../shared/helpers';

export default class extends Controller {
  static targets = ["destroy", "fileAttachmentTemplate"];

  connect() {
    App.Helpers.listenToCustomEvent(document, "message--file-select", this.addFileAttachmentBox.bind(this))
  }

  addFileAttachmentBox(event) {
    const { dataTransfer, formID, fileID } = event.detail
    if (formID === this.formID) {
      App.Helpers.appendContent(this.element, this.fileAttachmentTemplateFor(fileID))
      setTimeout((() => {
        dispatchCustomEvent("message--file-exchange", this.element, { dataTransfer, formID, fileID })
      }).bind(this), 100)
    }
  }

  removeExistingLink(event) {
    this.destroyTarget.value = "1"
    App.Helpers.hideElement(this.element)
  }

  removeNewLink(event) {
    this.element.remove()
  }

  get formID() {
    return this.data.get("form-id")
  }

  fileAttachmentTemplateFor(fileID) {
    return this.fileAttachmentTemplateTarget.innerHTML.replace(/INDEX_PLACEHOLDER/g, this.fileCount).replaceAll(this.formID, fileID)
  }

  get fileCount() {
    return [...this.element.querySelectorAll(".file")].length
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/messages/messages-forms-asset-controller.js